import React from 'react';

import { STATIC_ROOT } from '../../../constants';
import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

import SvgComponent from '../../SvgComponent';

//TODO Remove replaced styles
//import './ModalStatusComponent.scss';

export const ModalStatusComponent = ({
    partner = null,
    coupon = null,
    success = false,
    fetching = false,
    noRedirectionFailure = false,
    i18n
}) => {
    const renderLoadingStatus = () =>
        fetching ? (
            <div>
                {!coupon && (
                    <div className="bold">{`${i18n.CASHBACK_STATUS} ${i18n.CASHBACK_ACTIVATION_LOADING},`}</div>
                )}
                <div>
                    {i18n.REDIRECTION_PROCESS_LOADING}
                    {partner.name}...
                </div>
            </div>
        ) : null;

    const renderSuccessStatus = () =>
        !fetching && success ? (
            <div className="flex-container-h">
                <div>
                    {!coupon && (
                        <div className="bold success-message">
                            <span className="check-icon">
                                <SvgComponent
                                    src={`${STATIC_ROOT}/check.svg`}
                                    width="29"
                                    height="26"
                                />
                            </span>
                            {`${i18n.CASHBACK_STATUS} ${i18n.CASHBACK_ACTIVATION_SUCCESS}`}
                        </div>
                    )}
                    <div className="apparition-date">{i18n.ESTIMATED_APPARITION_DATE}</div>

                    <div className="loading">
                        {i18n.REDIRECTION_PROCESS_SUCCESS}
                        {partner.name}
                        <span className="loadingDots">
                            <span>.</span>
                            <span>.</span>
                            <span>.</span>
                        </span>
                    </div>
                </div>
            </div>
        ) : null;

    const renderFailureStatusWithRedirection = () =>
        !fetching && !success && !noRedirectionFailure ? (
            <div>
                {!coupon && (
                    <div className="bold">{`${i18n.CASHBACK_STATUS} ${i18n.CASHBACK_ACTIVATION_FAIL},`}</div>
                )}
                <div className="loading">
                    {i18n.REDIRECTION_PROCESS_FAIL_REDIRECTION}
                    {partner.name}
                    <span className="loadingDots">
                        <span>.</span>
                        <span>.</span>
                        <span>.</span>
                    </span>
                </div>
            </div>
        ) : null;

    const renderFailureStatusWithoutRedirection = () =>
        noRedirectionFailure ? (
            <div>
                {!coupon && (
                    <div className="bold">{`${i18n.CASHBACK_STATUS} ${i18n.CASHBACK_ACTIVATION_FAIL},`}</div>
                )}
                <div className="loading">
                    {i18n.REDIRECTION_PROCESS_FAIL}
                    <span className="loadingDots">
                        <span>.</span>
                        <span>.</span>
                        <span>.</span>
                    </span>
                </div>
            </div>
        ) : null;

    const renderConditionalStatusOnPartner = () =>
        !partner ? (
            convertHtmlToReactDomWithParams(i18n.PARTNER_UNDEFINED)
        ) : (
            <div>
                {renderLoadingStatus()}
                {renderSuccessStatus()}
                {renderFailureStatusWithRedirection()}
                {renderFailureStatusWithoutRedirection()}
            </div>
        );

    return (
        <section className="interstitiel-modal-status">
            {renderConditionalStatusOnPartner()}
        </section>
    );
};



// WEBPACK FOOTER //
// ./src/components/pages/interstitiel/ModalStatusComponent.js